<ng-container *ngIf="hasPayerData">
  <div class="modal-head-section">
    <h6 class="modal-header-text">Generate Bills</h6>
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      (click)="close()"
    >
      <g clip-path="url(#clip0_3558_32756)">
        <path
          d="M1.96338 16.9345L9.47846 9.41938M16.9935 1.9043L9.47703 9.41938M9.47703 9.41938L1.96338 1.9043M9.47846 9.41938L16.9935 16.9345"
          stroke="#F00000"
          stroke-width="2.16781"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3558_32756">
          <rect
            width="17.3425"
            height="17.3425"
            fill="white"
            transform="translate(0.806641 0.748047)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
  <div class="row justify-content-center p-4 m-0">
    <div class="col-md-12">
      <div class="w-100">
        <div
          class="my-3 fw-700"
          style="
            position: relative;
            border: 1px solid #ccc;
            border-radius: 10px;
            background: #fff;
          "
        >
          <b
            style="
              position: absolute;
              background: #fff;
              padding: 0 10px;
              top: -12px;
              left: 20px;
              border-radius: 5px;
            "
            >Payer Details</b
          >

          <form [formGroup]="form" autocomplete="off">
            <div>
              <div>
                <div class="row m-0 g-3 p-4 pt-0">
                  <div class="col-md-6">
                    <label class="form-label">Name</label>
                    <input
                      type="text"
                      class="form-control tax-input"
                      id="name"
                      formControlName="name"
                      placeholder="Enter full name"
                    />
                    <app-error-message
                      [form]="form"
                      [controlName]="'name'"
                    ></app-error-message>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">ASIN</label>
                    <input
                      type="text"
                      class="form-control tax-input"
                      id="asin"
                      formControlName="asin"
                      placeholder="Enter ASIN"
                    />
                    <app-error-message
                      [form]="form"
                      [controlName]="'asin'"
                    ></app-error-message>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label"> Phone Number</label>
                    <div class="w-100">
                      <ngx-intl-tel-input
                        [cssClass]="'form-control tax-input w-100'"
                        [customPlaceholder]="'Phone Number'"
                        [enableAutoCountrySelect]="true"
                        [enablePlaceholder]="true"
                        [id]="'telephoneNumber'"
                        [maxLength]="15"
                        [phoneValidation]="true"
                        [preferredCountries]="preferredCountries"
                        [searchCountryField]="[
                          SearchCountryField.Iso2,
                          SearchCountryField.Name,
                        ]"
                        [searchCountryFlag]="true"
                        [selectFirstCountry]="true"
                        [selectedCountryISO]="countryISO"
                        formControlName="phoneNumber"
                      ></ngx-intl-tel-input>
                      <app-error-message
                        [form]="form"
                        [controlName]="'phoneNumber'"
                      ></app-error-message>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Email</label>
                    <input
                      type="email"
                      class="form-control tax-input"
                      id="email"
                      formControlName="email"
                      placeholder="Enter email address"
                    />
                    <app-error-message
                      [form]="form"
                      [controlName]="'email'"
                    ></app-error-message>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <form [formGroup]="mdaForm" autocomplete="off">
        <div class="row g-3 d-flex mb-2" *ngIf="actor !== 'ADMIN'">
          <div class="col-md-12">
            <div class="form-group">
              <label class="required">Mda Name</label>
              <div class="input-group" *ngIf="!isFormReadonly">
                <ng-select
                  class="w-100"
                  [items]="mdas"
                  bindLabel="name"
                  bindValue="id"
                  placeholder="--Select MDA Name--"
                  formControlName="mdaId"
                  [searchable]="true"
                  [clearable]="true"
                >
                </ng-select>
              </div>

              <app-error-message
                [form]="mdaForm"
                [controlName]="'mdaId'"
              ></app-error-message>

              <!-- <div class="input-group" *ngIf="isFormReadonly">
                <input
                  *ngIf="isFormReadonly"
                  type="text"
                  class="form-control tax-input"
                  [value]="selecteMdaName"
                  [readonly]="isFormReadonly"
                />
              </div> -->
            </div>
          </div>
        </div>
        <div class="row g-3 d-flex">
          <div class="col-md-6">
            <div class="form-group">
              <label class="required">Revenue Name / Service Type</label>
              <div class="input-group" *ngIf="!isFormReadonly">
                <select class="form-select tax-select" formControlName="mda">
                  <option [value]="''">--Select Revenue Name--</option>
                  <option *ngFor="let m of mdaList" [value]="m?.id">
                    {{ m?.revenueName }}
                  </option>
                </select>
              </div>

              <app-error-message
                [form]="mdaForm"
                [controlName]="'mda'"
              ></app-error-message>

              <div class="input-group" *ngIf="isFormReadonly">
                <input
                  *ngIf="isFormReadonly"
                  type="text"
                  class="form-control tax-input"
                  [value]="selecteMdaName"
                  [readonly]="isFormReadonly"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="required">Service Type</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control tax-input"
                  formControlName="serviceType"
                  [readonly]="isFormReadonly"
                />
              </div>
              <app-error-message
                [form]="mdaForm"
                [controlName]="'serviceType'"
              ></app-error-message>
            </div>
          </div>

          <div *ngIf="serviceType == 'CUSTOM'" class="col-md-6">
            <div class="form-group">
              <label class="required">Custom Name</label>

              <div class="input-group" *ngIf="!isFormReadonly">
                <select
                  class="form-select tax-select"
                  formControlName="mdaCustomId"
                >
                  <option [value]="''">--Select Custom Name--</option>
                  <option
                    *ngFor="let m of mdaCustomDetailsList"
                    [value]="m?.id"
                  >
                    {{ m?.serviceName }}
                  </option>
                </select>
              </div>

              <app-error-message
                [form]="mdaForm"
                [controlName]="'mdaCustomId'"
              ></app-error-message>

              <div class="input-group" *ngIf="isFormReadonly">
                <input
                  *ngIf="isFormReadonly"
                  type="text"
                  class="form-control tax-input"
                  [value]="customIdName"
                  [readonly]="isFormReadonly"
                />
              </div>
            </div>
          </div>

          <div *ngIf="serviceType == 'CUSTOM'" class="col-md-6">
            <div class="form-group">
              <label class="required">Custom Type</label>
              <div class="input-group">
                <input
                  *ngIf="!showRegistrationAndRenewal"
                  type="text"
                  class="form-control tax-input"
                  formControlName="mdaCustomType"
                  [readonly]="isFormReadonly"
                />

                <select
                  *ngIf="showRegistrationAndRenewal"
                  class="form-select tax-select"
                  formControlName="mdaCustomType"
                >
                  <option [value]="''">--Select Type--</option>
                  <option *ngFor="let m of customSubTypes" [value]="m">
                    {{ m }}
                  </option>
                </select>
              </div>
              <app-error-message
                [form]="mdaForm"
                [controlName]="'mdaCustomType'"
              ></app-error-message>
            </div>
          </div>

          <div *ngIf="showVariable" class="col-md-6">
            <div class="form-group">
              <label class="required">Percentage(%)</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control tax-input"
                  formControlName="percentage"
                  [readonly]="isFormReadonly"
                />
              </div>
              <app-error-message
                [form]="mdaForm"
                [controlName]="'percentage'"
              ></app-error-message>
            </div>
          </div>
          <div class="col-md-6">
            <label class="required">Period Covered</label>

            <div class="input-group" *ngIf="isFormReadonly">
              <input
                *ngIf="isFormReadonly"
                type="text"
                class="form-control tax-input"
                [value]="selectedYear"
                [readonly]="isFormReadonly"
              />
            </div>
            <div *ngIf="!isFormReadonly" class="input-group">
              <input
                #dp="bsDatepicker"
                bsDatepicker
                type="text"
                class="form-control tax-input"
                placeholder="1990"
                formControlName="paymentPeriod"
                [maxDate]="now()"
                [bsConfig]="{
                  dateInputFormat: 'YYYY',
                  containerClass: 'theme-orange',
                  minMode: 'year',
                }"
                [readonly]="isFormReadonly"
              />

              <!-- <input #dp="bsDatepicker" bsDatepicker type="text"
                                class="form-control tax-input" placeholder="1990"
                                formControlName="paymentPeriod" [maxDate]="now()"
                                [bsConfig]="{ dateInputFormat: 'YYYY', containerClass: 'theme-orange' }" /> -->
              <span class="input-group-text bg-white" (click)="dp.toggle()"
                ><span class="iconify" data-icon="uil:calender"></span
              ></span>
            </div>
            <app-error-message
              [form]="mdaForm"
              [controlName]="'paymentPeriod'"
            ></app-error-message>
          </div>

          <div *ngIf="showVariable" class="col-md-6">
            <label class="required">Transaction Amount (₦)</label>
            <input
              type="text"
              placeholder="Enter Amount"
              class="form-control tax-input"
              formControlName="transactionAmount"
              separator
              [readonly]="isFormReadonly"
            />
            <app-error-message
              [form]="mdaForm"
              [controlName]="'transactionAmount'"
            ></app-error-message>
          </div>
          <div class="col-md-6">
            <label class="required">Total Payment Due</label>
            <input
              type="text"
              placeholder="Enter Amount"
              class="form-control tax-input"
              formControlName="paymentAmountDue"
              [readonly]="isFormReadonly"
            />
            <app-error-message
              [form]="mdaForm"
              [controlName]="'paymentAmountDue'"
            ></app-error-message>
          </div>
          <div class="col-md-12">
            <label class="fw-bold fs-18 required"
              >Transaction description</label
            >
            <div class="input-group">
              <input
                type="text"
                class="form-control tax-input small-option-font"
                placeholder="Enter Description"
                formControlName="transactionDescription"
                [readonly]="isFormReadonly"
              />
            </div>
            <app-error-message
              [form]="mdaForm"
              [controlName]="'transactionDescription'"
            ></app-error-message>
          </div>
        </div>

        <div
          *ngIf="
            showLocationIsApplicable ||
            showLandParamIsApplicable ||
            showPeriodIsApplicable ||
            showUploadsIsApplicable
          "
          class="row additional-details align-items-end mt-2 g-3"
        >
          <div class="col-12">
            <span class="text-decoration-underline">Additional Details</span>
          </div>
          <section *ngIf="showLocationIsApplicable" class="location">
            <h6 class="my-2">Location</h6>
            <div class="row g-3">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="required">Local Government</label>
                  <div *ngIf="!isFormReadonly" class="input-group">
                    <select
                      class="form-control tax-select"
                      formControlName="lga"
                      (change)="getAreas()"
                    >
                      <option [value]="" disabled>Select an option</option>
                      <option [value]="lga.id" *ngFor="let lga of lgas">
                        {{ lga.name | titlecase }}
                      </option>
                    </select>
                  </div>
                  <app-error-message
                    [form]="mdaForm"
                    [controlName]="'lga'"
                  ></app-error-message>

                  <div class="input-group" *ngIf="isFormReadonly">
                    <input
                      *ngIf="isFormReadonly"
                      type="text"
                      class="form-control tax-input"
                      [value]="selectedLgaName"
                      [readonly]="isFormReadonly"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="required">Local Government Area</label>
                  <div *ngIf="!isFormReadonly" class="input-group">
                    <select
                      class="form-control tax-select"
                      formControlName="area"
                    >
                      <option [value]="">Select an option</option>
                      <option [value]="area.id" *ngFor="let area of areas">
                        {{ area.name | titlecase }}
                      </option>
                    </select>
                  </div>
                  <app-error-message
                    [form]="mdaForm"
                    [controlName]="'area'"
                  ></app-error-message>

                  <div class="input-group" *ngIf="isFormReadonly">
                    <input
                      *ngIf="isFormReadonly"
                      type="text"
                      class="form-control tax-input"
                      [value]="selectedAreaName"
                      [readonly]="isFormReadonly"
                    />
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label class="required">Address</label>
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control tax-input"
                      formControlName="address"
                      placeholder="ENTER ADDRESS"
                      [readonly]="isFormReadonly"
                    />
                  </div>
                  <app-error-message
                    [form]="mdaForm"
                    [controlName]="'address'"
                  ></app-error-message>
                </div>
              </div>
            </div>
          </section>

          <div *ngIf="showLandParamIsApplicable" class="col-md-6">
            <section class="location">
              <h6 class="my-2">Land Parameters</h6>
              <div class="row">
                <div class="col-md-12">
                  <label class="fw-bold fs-18 required">Land Size (SQM)</label>
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control tax-input small-option-font"
                      placeholder="ENTER LAND SIZE"
                      formControlName="landSize"
                      min="1"
                      [readonly]="isFormReadonly"
                    />
                  </div>
                  <app-error-message
                    [form]="mdaForm"
                    [controlName]="'landSize'"
                  ></app-error-message>
                </div>
              </div>
            </section>
          </div>
          <div *ngIf="showPeriodIsApplicable" class="col-md-6">
            <h6 class="my-2">Period</h6>

            <label class="fw-bold fs-18 required">Year</label>
            <div *ngIf="!isFormReadonly" class="input-group">
              <!-- <input type="date" class="form-control tax-input small-option-font"
                                 formControlName="period"> -->

              <input
                #dp="bsDatepicker"
                bsDatepicker
                type="text"
                class="form-control tax-input"
                placeholder="1990"
                formControlName="period"
                [maxDate]="now()"
                [bsConfig]="{
                  dateInputFormat: 'YYYY',
                  containerClass: 'theme-orange',
                  minMode: 'year',
                }"
                [readonly]="isFormReadonly"
              />
            </div>

            <div class="input-group" *ngIf="isFormReadonly">
              <input
                *ngIf="isFormReadonly"
                type="text"
                class="form-control tax-input"
                [value]="selectedYear"
                [readonly]="isFormReadonly"
              />
            </div>
            <app-error-message
              [form]="mdaForm"
              [controlName]="'period'"
            ></app-error-message>
          </div>
          <div
            *ngIf="showUploadsIsApplicable && serviceType != 'CUSTOM'"
            class="col-md-12"
          >
            <div class="upload-group">
              <h6>Upload</h6>
              <div class="upload-container">
                <input
                  *ngIf="!isFormReadonly"
                  type="file"
                  (change)="onUploadChange($event)"
                  accept="image/*, application/pdf"
                  [readonly]="isFormReadonly"
                />
              </div>
            </div>
            <app-error-message
              [form]="mdaForm"
              [controlName]="'upload'"
            ></app-error-message>
          </div>
        </div>
      </form>

      <div class="row additional-details align-items-end mt-2 g-3">
        <div
          *ngIf="showUploadsIsApplicable && serviceType == 'CUSTOM'"
          class="col-md-12"
        >
          <div class="upload-group">
            <h6>Upload</h6>

            <div class="upload-container d-flex align-items-center gap-2">
              <!-- Smaller select with spacing -->
              <select
                class="form-select form-select-sm"
                style="width: 250px"
                [(ngModel)]="selectedUploadableId"
                [disabled]="isFormReadonly"
              >
                <option [ngValue]="null">-- Select Document --</option>
                <option
                  *ngFor="let item of mdaCustomUploadablesList"
                  [ngValue]="item.id"
                  [disabled]="uploadedIds.includes(item.id)"
                >
                  {{ item.name }}
                </option>
              </select>

              <!-- File input with spacing -->
              <input
                *ngIf="!isFormReadonly"
                type="file"
                (change)="onEachUploadChange($event)"
                accept="image/*, application/pdf"
                [disabled]="!selectedUploadableId"
                class="form-control form-control-sm"
                style="width: 300px"
              />
            </div>
          </div>

          <!-- Uploaded table -->
          <table class="table mt-3" *ngIf="uploadedFiles.length > 0">
            <thead>
              <tr>
                <th>Document</th>
                <th>File</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let file of uploadedFiles; let i = index">
                <td>{{ file.name }}</td>
                <td>{{ file.upload?.name }}</td>
                <td>
                  <button
                    class="btn btn-danger btn-sm"
                    (click)="removeUploadedFile(i)"
                    [disabled]="isFormReadonly"
                  >
                    Remove
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="mt-3 row g-2">
        <div *ngIf="!isFormReadonly" class="col-md-12 p-0">
          <button
            (click)="setToReadonly()"
            style="font-size: 14px; width: 100%"
            class="btn btn-success btn-lg rounded-1 p-2"
          >
            <span>Proceed</span>
          </button>
        </div>

        <div class="col-md-12">
          <button
            [disabled]="submitting"
            *ngIf="isFormReadonly"
            (click)="createAndPay()"
            style="font-size: 14px; width: 100%"
            class="btn btn-primary btn-lg rounded-0"
          >
            Save and Pay Online
          </button>
        </div>

        <div class="col-md-6">
          <button
            [disabled]="submitting"
            *ngIf="isFormReadonly"
            (click)="setToEditable()"
            style="font-size: 14px; width: 100%"
            class="btn btn-secondary btn-lg rounded-0"
          >
            Edit
          </button>
        </div>

        <div *ngIf="isFormReadonly" class="col-md-6">
          <button
            [disabled]="submitting"
            (click)="create()"
            style="font-size: 14px; width: 100%"
            class="btn btn-success btn-lg rounded-0"
          >
            <span>Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
